<template>
  <div class="content content-full">
    <div class="page-navs bg-white">
      <div class="nav-scroller">
        <div class="nav nav-tabs nav-line nav-color-secondary d-flex align-items-center justify-contents-center w-100">
          <router-link class="nav-link" to="/account/subscription">
            <i class="fa fa-chevron-left mr-2"></i>{{ $t('account') }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="page-inner">
      <h2><i class="fa fa-exclamation-triangle text-warning mr-1"></i> {{ $t('wait_before_cancelling') }}</h2>
      <p>{{ $t('cancelling_explanation') }}</p>
      <ul>
        <li>{{ $t('unlimited_artists') }}</li>
        <li>{{ $t('premium_platforms') }}</li>
        <li>{{ $t('extra_promotion_tools') }}</li>
      </ul>
      <h4>{{ $t('reduced_royalties') }}</h4>
      <p>{{ $t('reduced_royalties_desc') }}</p>
      <h4>{{ $t('songs_taken_down') }}</h4>
      <p>{{ $t('songs_taken_down_desc')}}</p>
      <h4>{{ $t('payment_requests') }}</h4>
      <p>{{ $t('payment_requests_will_cancelled') }}</p>
      <div>
        <button class="btn btn-danger btn-sm" type="button" @click="cancelSubscriptionModal()">
          {{ $t('cancel_subscription') }}
        </button>
      </div>
    </div>

    <div ref="cancelSubscriptionModal" class="modal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="text-center">
              <!-- <img src="/static/img/crying.gif" width="65%"/> -->
              <div class="mt-3">
                <div class="fw-bold h3">
                  {{ $t('sorry_you_go') }}
                </div>
                <div class="mt-2">
                  {{ $t('before_cancel_comment') }}
                </div>
                <div class="mt-3 text-left">
                  <ul class="list-unstyled list-reason">
                    <li>
                      <label for="check_expensive" class="form-check-label">
                        <input v-model="reasons.expensive" type="checkbox" id="check_expensive" class="custom-checkbox mr-1"> {{ $t('too_expensive') }}
                      </label>
                    </li>
                    <li>
                      <label for="check_errors" class="form-check-label">
                        <input v-model="reasons.issues" type="checkbox" id="check_errors" class="custom-checkbox mr-1"> {{ $t('technical_issues') }}
                      </label>
                    </li>
                    <li>
                      <label for="check_tools" class="form-check-label">
                        <input type="checkbox" v-model="reasons.unnecessary_tools" id="check_tools" class="custom-checkbox mr-1"> {{ $t('unnecessary_tools') }}
                      </label>
                    </li>
                    <li>
                      <label for="no_more_music" class="form-check-label">
                        <input type="checkbox" v-model="reasons.no_more_music" id="no_more_music" class="custom-checkbox mr-1"> {{ $t('no_more_music') }}
                      </label>
                    </li>
                    <li>
                      <label for="check_not_understood" class="form-check-label">
                        <input type="checkbox" v-model="reasons.not_understood" id="check_not_understood" class="custom-checkbox mr-1"> {{ $t('not_understood') }}
                      </label>
                    </li>
                    <li>
                      <label for="check_other" class="form-check-label">
                        <input v-model="otherReason" type="checkbox" id="check_other" class="custom-checkbox mr-1"> {{ $t('custom_cancel_reason') }}
                      </label>
                    </li>
                  </ul>
                  <div v-if="otherReason">
                    <textarea :placeholder="$t('custom_cancel_reason_placeholder')" v-model="reasons.other" class="form-control" rows="3"></textarea>
                  </div>
                  <div class="text-center mt-4">
                    <button type="button" class="btn btn-primary mb-3" data-dismiss="modal">
                      {{ $t('do_not_cancel') }}
                    </button><br/>
                    <p>
                      <i class="fa fa-exclamation-triangle text-warning mr-1"></i> {{ $t('payment_requests_will_cancelled') }}
                    </p>
                    <a href="javascript:void(0)" @click="cancelSubscription()" class="text-danger btn-block mt-3 mb-2">
                      {{ $t('end_membership') }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import User from '../services/user'

export default {
  name: 'CancelSubscription',
  data () {
    return {
      otherReason: false,
      reasons: {},
      user: {},
      subscription: {}
    }
  },
  computed: {
  },
  methods: {
    cancelSubscriptionModal: function () {
      window.$(this.$refs.cancelSubscriptionModal).modal('show')
    },
    cancelSubscription: function () {
      window.$(this.$refs.cancelSubscriptionModal).modal('hide')

      if (this.subscription.source === 'paypal') {
        this.showPaypalInstructions = true
      } else {
        this.subscription.cancelled = 1

        User.cancelSubscription().then(response => {
          this.$notify({ message: this.$t('subscription_cancelled') }, 'success', 'fa-check')
        })
      }

      User.sendChurnFeedback(this.reasons)
      this.reasons = {}
    }
  },
  created: function () {
    this.user = this.$user

    if (this.user.subscription) {
      User.getSubscription().then(response => {
        this.subscription = response.data
      })
    }
  },
  mounted: function () {
    if (this.$route.query.stripe_created) {
      this.$notify({ message: this.$t('stripe_created_sucess') }, 'success', 'fa-check')
    }
  },
  components: {
  }
}
</script>
<style lang="scss" scoped>
.list-reason {
  li {
    margin-bottom: 10px;

    input {
      position: relative;
      top: 2px;
    }
  }
}

textarea {
  resize: none;
}

.logo-stripe {
  max-width: 85px;
}
</style>



// WEBPACK FOOTER //
// src/components/CancelSubscription.vue